import { MBEmptyListPlaceholder } from '@shared/components/list/emptyListPlaceholder';
import { i18n } from '@shared/util/i18n';

export function NoCards() {
  return <MBEmptyListPlaceholder description={i18n('card.blocks.cardsInput.emptyState')} />;
}
